import { SubscriptionProduct } from "@redotech/redo-billing-common/unified-billing/enums";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const billingProductBundleDiscount = z.object({
  product: createEnum(SubscriptionProduct, { enumName: "SubscriptionProduct" }),
  percentOff: z.number().int().min(1).max(100),
});

export const billingProductBundle = z.object({
  id: z.string().min(1),
  products: z
    .array(createEnum(SubscriptionProduct, { enumName: "SubscriptionProduct" }))
    .min(1),
  discounts: z.array(billingProductBundleDiscount).optional(),
});

export type BillingProductBundle = z.infer<typeof billingProductBundle>;

export const getBillingProductBundles = {
  name: "getBillingProductBundles" as const,
  input: z.null(),
  output: z.array(billingProductBundle),
};
